import * as React from "react";
import { style } from "typestyle";
import { FunctionComponent } from "react";
import { ButtonStyleTypes } from "@traceair/tds";
import { stylesSet } from "@traceair/tds/dist/styles/button";

interface Props {
  iconComponent?: FunctionComponent<{ color: string; size: string }>;
  color: string;
  background: string;
  label: string;
  onClick: () => void;
}
const WideButton: FunctionComponent<Props> = ({
  iconComponent,
  label,
  color,
  background,
  onClick,
}: Props) => (
  <div
    className={style({
      display: "flex",
      width: "100%",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "20px",
      height: "56px",
      boxShadow:
        "0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12)",
      cursor: "pointer",
      color,
      background,
      borderRadius: "12px",
    })}
    onClick={onClick || (() => null)}
  >
    {iconComponent && (
      <div className={style({ margin: "0 8px", display: "flex" })}>
        {React.createElement(iconComponent, {
          color: color,
          size: "32px",
        })}
      </div>
    )}
    <div>{label}</div>
  </div>
);

export default WideButton;
